import { render } from "./App.vue?vue&type=template&id=5b76b96c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5b76b96c&lang=css"

import exportComponent from "C:\\Users\\EzioHelios\\Dev\\web\\ProjectC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__